<template>
  <div class="team-overview-filter mt-3 mb-3">
    <!--    <pre class="text-white">-->
    <!--      {{filteredTree}}-->
    <!--    </pre>-->
    <div v-if="deletepopup" class="popup-backdrop position-fixed w-100 h-100">
      <div class="justify-content-center d-flex popup-bg position-absolute w-100 h-100 row m-0 align-content-center">
        <div class="popup-modal position-relative col-md-4">
          <h3>{{$t('message.delete_filter')}}</h3>
          <p>{{$t('message.are_you_sure')}}</p>
          <p class="text-right m-0">
            <button @click.prevent="deletepopup = false" class="btn btn-link">{{$t('message.cancel')}}</button>
            <button @click.prevent="deletefilter(deletepopup)" class="btn btn-primary">{{$t('message.delete')}}</button>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <div class="row">
          <div class="col-auto">
            <button @click="()=>{showFilter = !showFilter; if(filterRows.length === 0 ){addRow()}}"
                    class="mt-1 btn button btn-link p-0 filter-title">
              {{ $t('message.filter') }}
              <span v-show="!showFilter"><i class="fas fa-fw fa-caret-right"></i></span>
              <span v-show="showFilter"><i class="fas fa-fw fa-caret-down"></i></span>
            </button>
          </div>

          <!--          <div class="ml-3 col flat-date-pickr">-->
          <!--            <div class="row-flex flex-v">-->
          <!--              <span>{{ $t('message.to') }}</span>-->
          <!--              <input @change="(startDate,endDate)" v-model="endDate" type="date"-->
          <!--                     class="ml-1 mb-0 styled-input c_date_picker form-control">-->
          <!--            </div>-->
          <!--          </div>-->
        </div>

      </div>
      <div v-show="savedFilters.length" class="col ml-auto text-right">
        <select v-model="selectedFilter.id" id="selected-filter" @change="savedFilterHandler"
                class="d-none ml-auto btn btn-default button">
          <option selected disabled value="">{{ $t('message.saved_filters') }}</option>
          <template v-for="filter in savedFilters">
            <option :value="filter.id">{{filter.title}}</option>
          </template>
        </select>
        <div class="pos-rel filter-item-select custom-select styled-input form-control"
             @click="savedFiltersShown = !savedFiltersShown">
          <div :class="selectedFilter.id ? '' : 'text-muted'" class="pos-rel filter-item-selected"
               :data-filter="selectedFilter.id">{{selectedFilter.title|| $t('message.select_a_filter')}}
          </div>
          <div class="pos-rel filter-item-list form-control styled-input" v-if="savedFiltersShown">
            <div v-for="filter in savedFilters"
                 v-if="filter !== selectedFilter"
                 class="pos-rel filter-item-option"
                 @click="selectedFilter = filter"
                 :data-filter="filter.id">

              <span class="fname">
                {{filter.title}}
              </span>
              <span class="fdelete">
                <button @click.prevent.stop="deletepopup = filter.id" class="btn btn-link">
                  <i class="fal fa-times"></i>
                </button>
              </span>
              <!--              <span class="action">-->
              <!--                <button class="btn btn-link"></button>-->
              <!--              </span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <form v-if="showFilter" class="filter-content mt-3">
      <template v-if="filterRows.length > 0" v-for="(filter,i) in filterRows">
        <filter-row @removeRow="removeRow(i)" :last="(i === (filterRows.length-1))" :perks="perks" :tags="tags" :i="i"
                    :filter-data="filter"></filter-row>
      </template>
      <div class="form-group row add-filter">
        <div class="col-md-2">
          <button @click.prevent="addRow" class="button btn styled-input  btn-filter">
            <span class="plus">+</span>&nbsp;{{ $t('message.add_filter') }}
          </button>
        </div>
      </div>
      <div class="form-group row filter-actions">
        <div class="col-md-6">
          <input v-model="filterName"
                 v-on:keydown.enter.prevent="saveFilter"
                 placeholder="Name your filter" type="text"
                 class="mb-0 form-control styled-input">
        </div>
        <div class="col-md-2">
          <button @click.prevent="runFilters"
                  class="button btn btn-secondary w-100 btn-filter-fill h-100">
            {{ $t('message.filter') }}
          </button>
        </div>
        <div class="col-md-2">
          <button @click.prevent="saveFilter"
                  class="button btn btn-secondary w-100 btn-filter-fill h-100">
            {{ $t('message.save') }}
          </button>
        </div>
        <div class="col-md-2">
          <button @click.prevent.stop="clearFilters"
                  class="button btn btn-secondary w-100 btn-filter-fill h-100">
            {{ $t('message.clear') }}
          </button>
        </div>
        <div class="col-md-12" v-if="filterErrors.length">
          <ul class="mt-2 mb-0 text-danger">
            <li v-for="e in filterErrors">{{e}}</li>
          </ul>
        </div>
        <!--        <button @click.prevent="test">test</button>-->
      </div>
    </form>
  </div>
</template>
<script>
  import store from "../../store/store";
  import CompanyTreeFilterRow from "./CompanyTreeFilterRow";

  export default {
    components: {
      filterRow: CompanyTreeFilterRow,
    },
    created() {
      this.filteredTree = JSON.parse(JSON.stringify(this.tree));
      this.getUserFilters()
    },
    mounted() {
    },
    data() {
      return {
        deletepopup: false,
        savedFiltersShown: false,
        filterErrors: [],
        selectedFilter: '',
        filterName: '',
        activeFilter: {},
        showFilter: false,
        savedFilters: [],
        filterRows: [],
        filteredTree: {},
        tags: [],
        perks: [],
        filters: {},
      }
    },
    props: {
      tree: {
        type: Object,
        default() {
          return null
        }
      },
    },
    watch: {
      selectedFilter() {
        this.savedFilterHandler()
      }
    },
    methods: {
      deletefilter(filter_id) {
        this.axios.delete('/filters/' + filter_id).then(r => {
          //   console.log('deleted', r);
          this.savedFilters.forEach((filter, ind) => {
            if (filter.id == filter_id) {
              this.savedFilters.splice(ind, 1)
              this.deletepopup = false;
            }
          });
        })
      },
      test() {
        this.filterRows = [{field: 'birthdate'}, {field: 'median'}]
      },
      savedFilterHandler(e) {
        if (this.selectedFilter !== '') {
          // const filter_id = e.target.value;
          const filter_id = this.selectedFilter.id;
          this.clearFilters(false);
          // this.resetResults();

          this.savedFilters.forEach(filter => {
            if (filter.id == filter_id) {
              this.filterName = filter.title;
              const filterList = JSON.parse(filter.filter);
              for (let filterKey in filterList) {
                this.$set(this.filterRows, filterKey, filterList[filterKey]); //todo properly reactive filter rows when loading filter
                this.filtering = true;
                this.showFilter = true;
                filterList[filterKey].i = parseInt(filterKey);
                store.commit('addTeamFilter', filterList[filterKey])
              }
            }
          });
          const newFilters = store.getters.teamFilters;
          this.runFilters()
        }
      },

      returnFilter(reset = false) {
       // console.log('returning filter',this.filteredTree)
        this.$emit('filterHandler', [this.filteredTree, reset]);
      },
      getUserFilters() {
        this.axios.get('/filters?user=' + store.getters.getUserId).then(filters => filters.data)
          .then(res => {
            // console.log('user filters', res)
            const data = res;
            this.savedFilters = data;
          });
      },
      loadTagsForFilter() {
        this.axios.get('/tags').then(tags => tags.data)
          .then(res => {
            const data = res;
            this.tags = [];
            data.forEach(tag => {
              this.tags.push({key: tag.id, label: tag.description})
            });
          });
      },
      loadPerksForFilter() {
        this.axios.get('/perks').then(perks => perks.data)
          .then(res => {
            const data = res;
            this.perks = [];
            data.forEach(perk => {
              this.perks.push({key: perk.id, label: perk.title})
            });
          });
      },
      saveFilter(e) {
        this.filterErrors = [];
        const filter = (store.getters.teamFilters);
        if (!this.isEmptyObject(filter) && this.filterName.length > 0) {
          let el = e.target;
          el.classList.add('loading');
          this.axios.post('/filters', {
            user: store.getters.getUserId,
            title: this.filterName,
            filter: JSON.stringify(filter)
          }).then(res => {
            this.savedFilters.push(res.data)
            this.filterName = '';
            this.logActivity('Saved filter', 'info');
            el.classList.remove('loading')
            // setTimeout(()=>{
            this.filterErrors.push(this.$t('message.filter_saved_successfully'));
            // },1000);
            setTimeout(() => {
              this.filterErrors = []
            }, 2000)
          }).catch(res => {
            el.classList.remove('loading')
          })
        } else {
          if (this.isEmptyObject(filter)) {
            this.filterErrors.push(this.$t('message.no_filters_chosen'))
          }
          if (this.filterName.length === 0) {
            this.filterErrors.push(this.$t('message.filter_name_empty'))
          }

        }

      },

      async clearFilters(reset = true) {
        // console.log('clearing filters function')
        store.commit('removeAllFilters')
        if (reset) {
          this.selectedFilter = '';
          document.querySelector('#selected-filter').selectedIndex = 0
        }
        this.filterRows = [];
        this.filterName = '';
        this.addRow();
        this.filtering = false;
        this.resetResults();
        this.returnFilter(true);
        this.showFilter = false;
      },

      resetResults() {
        this.filterErrors = [];
        this.filterTrees = [];
        this.filteredTree = JSON.parse(JSON.stringify(this.tree));
      },

      runFilters() {
        // console.log('running filters')
        this.filterErrors = [];
        this.resetResults();
        // console.log('filter rows', this.filterRows);
        let filters = store.getters.teamFilters;
        // console.log('store filters', filters)
        if (!this.isEmptyObject(filters)) {

          this.filtering = true;
          let activeTree = 0;

          let teamTree = JSON.parse(JSON.stringify(this.tree)); //todo make this less resource intensive
          teamTree.show = true; //always show top company block
          this.filterTrees.push(teamTree);

          let nextLogic = '';
          for (let key in filters) { //for every filter, filter all teams
            if (nextLogic === 'or') {
              let newTree = JSON.parse(JSON.stringify(this.tree)); //todo make this less resource intensive
              newTree.show = true; //always show top company block
              this.filterTrees.push(newTree);
              activeTree++
            }
            if (nextLogic === 'not') {
              filters[key].not = true;
            }
            // console.log('applying filter', filters[key])
            this.applyFilterToTree(filters[key], this.filterTrees[activeTree]);
            nextLogic = filters[key].logic;
          }

          let resultTree = JSON.parse(JSON.stringify(this.tree));

          resultTree.show = true;
          this.filterTrees.forEach(filtertree => this.compareTrees(resultTree, filtertree));
          this.filteredTree = resultTree;

          this.returnFilter();
        } else {
          this.filterErrors.push(this.$t('message.no_filters_chosen'))
        }

      },

      compareTrees(sourceTree, targetTree) {
        if (sourceTree.teams) {
          sourceTree.teams.forEach((sourceChild, index) => this.compareTeamToTree(sourceChild, targetTree.teams[index]))
        }
      },

      compareTeamToTree(sourceChild, targetChild) {
        //actual comparison here
        if (targetChild) {



          if (sourceChild.users && targetChild.users) {
            sourceChild.users.forEach((member, index) => {
              if (targetChild.users[index].show) {
                member.show = true;
              }
            })
          }

          if (sourceChild.teams) {
            sourceChild.teams.forEach((srcChild, index) => this.compareTeamToTree(srcChild, targetChild.teams[index]))
          }

          if (targetChild.show) {
            sourceChild.show = true
          }
        }
      },

      applyFilterToTree(filter, company) {
        // console.log('filtering tree', filter, company)
        if (filter.field === 'average' || filter.field === 'median' || filter.field === 'lowest' || filter.field === 'highest') {
          switch (filter.value) {
            case "cs":
              filter.value = company[filter.field];
              // console.log('company score filter, value:', filter.value)
              break;
            default:
              break;
          }
        }


        if (company.teams) { //dont filter if company has no teams
          company.teams.forEach(team => { //filter each team in the company tree
            if (team.status) {
              this.filterTeam(filter, team)
            }
          })
        }
      },

      filterTeam(filter, team) {

        team.title = 'filtered';
        let visible = false;

        let teamMatchesFilter = this.matchFilterForTeam(team, filter);
        let hasMatchingChildren = false;

        if (team.teams) {
          team.teams.forEach((childteam, i) => {
            let childMatches = this.filterTeam(filter, childteam);
            if (childMatches) {
              hasMatchingChildren = true;
            }
          });
        }

        if (teamMatchesFilter || hasMatchingChildren) {
          visible = true;
        }
        team.show = visible;
        return visible;
      },

      matchFilterForTeam(team, filter) {
        //todo if filter type = team, filter team fields, else run below to filter users
        //todo if there are only team filters, show all users for filtered teams

        let currentResult = false;
        if (team.users) {
          team.users.forEach((member, i) => {
            member.teamaverage = team.average;
            member.teammedian = team.median;
            member.teamlowest = team.lowest;
            member.teamhighest = team.highest;
            //todo load and set company averages
            let visible = false;
            let matchesFilter = this.matchFilterForUser(member, filter);
            if(!matchesFilter){
              member.failedFilter = true;
            }

            if(matchesFilter && !member.failedFilter){
              visible = true;
              currentResult = true
            }else{
              visible = false
            }
            member.show = visible;
            if(visible){
              currentResult = true
            }


            // if (!member.failedFilter) {
            //   let filterResult = this.matchFilterForUser(member, filter);
            //   if (!filterResult) {
            //     member.failedFilter = true;
            //   } else {
            //     matchingUsers.push(member)
            //     currentresult = true;
            //     member.show = true;
            //   }
            // } else {
            //   member.show = false;
            // }
          })
        }
        // console.log('matching users',currentResult)
        return currentResult;
      },

      matchFilterForUser(member, filter) {
        // console.log('matching filter for user', member, filter)
        let filtervalue = filter.value;


        switch (filter.field) {
          case 'birthdate':
            // console.log('age filter')
            member.birthdate = this.calcAge(member.birthdate);
            break;
          case'avgscore_difference_team':
            member['avgscore_difference_team'] = Math.abs(member.average - member.teamaverage);
            break;
          case 'avgscore_difference_company':
            member['avgscore_difference_company'] = Math.abs(member.average - this.teams.average);
            break;
        }

        if (filter.field === 'average' || filter.field === 'median' || filter.field === 'lowest' || filter.field === 'highest') {
          switch (filter.value) {
            case "ts":
              filtervalue = member['team' + filter.field];
              break;
            default:
              break;
          }
        }


        let showuser = false;
        // console.log('checking filter operator', filter.operator)
        switch (filter.operator) {
          case "equals":
            if (filter.field === 'children') {
              let childrenCount = member[filter.field].length;
              if (childrenCount === parseInt(filtervalue)) {
                showuser = true;
              }
            } else {
              if (typeof member[filter.field] === "string" && typeof filtervalue === "string") {
                // console.log('strings')
                if (member[filter.field] ? (member[filter.field].toUpperCase() === filtervalue.toUpperCase()) : false) {

                  showuser = true;
                }
              } else {
                if (member[filter.field] ? (member[filter.field] == filtervalue) : false) {
                  showuser = true;
                }
              }

            }

            break;
          case "noequals":
            if (filter.field === 'children') {
              let childrenCount = member[filter.field].length;
              if (childrenCount !== parseInt(filtervalue)) {
                showuser = true;
              }
            } else {
              if (typeof member[filter.field] === "string" && typeof filtervalue === "string") {
                if (member[filter.field] ? (member[filter.field].toUpperCase() !== filtervalue.toUpperCase()) : false) {
                  showuser = true;
                }
              } else {
                if (member[filter.field] ? (member[filter.field] != filtervalue) : false) {
                  showuser = true;
                }
              }

            }

            break;
          case "contains":
            // console.log('contains filter')
            if (filter.field === "tags") {
              member.tags.forEach(tag => {
                if (filtervalue === tag.id) {
                  showuser = true;
                }
              })
            } else if (filter.field === "perks") {
              member.perks.forEach(perk => {
                if (filtervalue === perk.id) {
                  showuser = true;
                }
              })
            } else {
              // console.log('field is not tags or perks')
              if (typeof member[filter.field] === "string" && typeof filtervalue === "string") {

                if (member[filter.field] ? (member[filter.field].toUpperCase().includes(filtervalue.toUpperCase())) : false) {
                  // console.log('user can be shown', member)
                  showuser = true;
                }
              } else {
                if (member[filter.field] ? (member[filter.field].includes(filtervalue)) : false) {
                  // console.log('user can be shown', member)
                  showuser = true;
                }
              }

            }
            break;
          case "nocontain":
            if (filter.field === "tags") {
              member.tags.forEach(tag => {
                if (filtervalue == tag.id) {
                  showuser = false;
                }
              })
            } else {
              if (typeof member[filter.field] === "string" && typeof filtervalue === "string") {
                if (!member[filter.field].toUpperCase().includes(filtervalue.toUpperCase())) {
                  showuser = true;
                }
              } else {
                if (!member[filter.field].includes(filtervalue)) {
                  showuser = true;
                }
              }

            }

            break;
          case "distance":
            //todo compare distance between coordinates
            break;
          case "less":


            switch (filter.type) {
              case 'date':
                if (moment(member[filter.field]).isBefore(moment(filtervalue))) {
                  showuser = true;
                }
                break;
              default:
                if (filter.field === 'children') {
                  if (member[filter.field].length < filtervalue) {
                    showuser = true;
                  }
                } else {
                  if (member[filter.field] < filtervalue) {
                    showuser = true;
                  }
                }
                break;
            }


            break;
          case "more":

            switch (filter.type) {
              case 'date':
                if (moment(member[filter.field]).isAfter(moment(filtervalue))) {
                  showuser = true;
                }
                break;
              default:
                if (filter.field === 'children') {
                  if (member[filter.field].length > filtervalue) {
                    showuser = true;
                  }
                } else {
                  if (member[filter.field] > filtervalue) {
                    showuser = true;
                  }
                }
                break;
            }


            break;
        }

        if (filter.not) {
          showuser = !showuser
        }
// console.log('filtered user',filter,member,showuser)
        return showuser;
      },

      addRow(e, filter = {
        field: '',
        operator: '',
        value: '',
        logic: 'and'
      }) {
        //   console.log('adding filter row', filter)
        this.filterRows.push(filter)
      },

      removeRow(i) {
        //   console.log('remove filter',i)
        store.dispatch('removeFilter', i);
        this.filterRows.splice(i, 1);
        this.runFilters();
        // this.filterRows[i].field = null
      },
    }
  }
</script>


<style>
  span.fdelete {
    margin-right: -25px;
  }

  .popup-backdrop {
    z-index: 100;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.0125);
  }

  .popup-modal {
    padding: 15px;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tree/CompanyTreeFilter.vue